import React from "react";

interface ClipBlackProps {
  children: React.ReactNode;
}
export const ClipBlack = (props: ClipBlackProps) => {
  return <div className="text-black font-monument">{props.children}</div>;
};
